import { IconUtensils } from "../../../../shared/icons";
import { ProcessedRestaurant } from "../../../../../hooks/useProcessedRestaurants";
import styles from "./RestaurantList.module.scss";
import RestaurantItem from "./RestaurantItem/RestaurantItem";

interface Props {
  items: ProcessedRestaurant[];
  selectedId: number | undefined;
  primaryColor: string;
  itemRefs: React.MutableRefObject<Record<number, HTMLDivElement | null>>;
  onItemClick: (item: ProcessedRestaurant) => void;
  onDirections: (item: ProcessedRestaurant) => void;
}

const RestaurantList = ({
  items, selectedId, primaryColor, itemRefs, onItemClick, onDirections,
}: Props) => {
  if (items.length === 0) {
    return (
      <div className={styles.list}>
        <div className={styles.empty}>
          <span className={styles.emptyIcon}><IconUtensils size={36} /></span>
          <p>Aucun restaurant trouvé</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.list}>
      {items.map((item, index) => {
        const isSelected = selectedId === item.id;
        const isNearest = index === 0 && item._dist !== null;
        return (
          <div key={item.id}>
            <RestaurantItem
              ref={(el) => (itemRefs.current[item.id] = el)}
              item={item}
              isSelected={isSelected}
              isNearest={isNearest}
              primaryColor={primaryColor}
              onClick={() => onItemClick(item)}
              onDirections={() => onDirections(item)}
            />
            {index < items.length - 1 && <div className={styles.divider} />}
          </div>
        );
      })}
    </div>
  );
};

export default RestaurantList;